/**
 * Caption profanity masking: listed words render as their first letter plus asterisks ("f***").
 * The backend keeps the same list in backend/modal_workers/utils/captions/profanity.py (email still):
 * change both together. The transcript always shows the original words.
 */
export const PROFANE_WORDS = new Set([
  "fuck", "fucking", "fuckin", "fucked", "fucker", "fuckers", "fucks", "motherfucker", "motherfuckers",
  "shit", "shitty", "shits", "bullshit", "bitch", "bitches", "bastard", "asshole", "assholes",
  "dick", "dicks", "pussy", "cunt", "cunts", "cock", "whore", "slut",
  "nigga", "niggas", "nigger", "niggers", "fag", "faggot", "retard", "twat", "wanker", "prick",
])

/** The text with every listed word masked, keeping punctuation and the first letter's case. */
export function maskProfanity(text: string): string {
  return text.replace(/[A-Za-z']+/g, (token) =>
    PROFANE_WORDS.has(token.toLowerCase().replace(/'/g, "")) ? token[0] + "*".repeat(token.length - 1) : token)
}
